// extracted by mini-css-extract-plugin
export var container = "_jc-0";
export var dotAnimation = "_jc-2";
export var dotsLoading = "_jc-1";